var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRwanda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#305f3e",
    d: "M30 24H0v-6h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4d548",
    d: "M0 12h30v6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4aa2dc",
    d: "M30 12H0V0h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4d548",
    d: "m23.66 6.84 3-.17-3-.18 2.86-.94-2.95.6L26.1 4.5l-2.7 1.35 2-2.25-2.24 2 1.35-2.69-1.65 2.52.6-2.95-.94 2.86-.18-3-.17 3-.95-2.86.61 2.95-1.65-2.52 1.35 2.7-2.25-2 2 2.24-2.69-1.35 2.51 1.65-2.94-.6 2.85.94-3 .18 3 .17-2.85.95 2.94-.61-2.5 1.65 2.68-1.35-2 2.25 2.25-2-1.35 2.69 1.65-2.51-.6 2.94.94-2.85.17 3 .18-3 .94 2.85-.6-2.94 1.65 2.5-1.35-2.68 2.25 2-2-2.25 2.69 1.35-2.52-1.65 2.95.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwanda);
export default __webpack_public_path__ + "static/media/rwanda.40bd502a061ffbd3c30120d3b5e204ee.svg";
export { ForwardRef as ReactComponent };